/* === INBUS — Cart Snap — V2 (properties-driven, silent fallback) ===
   File: assets/inb-cart-discountbar.js
*/
(function(){
  function onReady(fn){ document.readyState!=='loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function toInt(v){ var n=parseInt(String(v||'').replace(/\D/g,''),10); return isNaN(n)?0:n; }
  function clampMin1(n){ return n<1?1:n; }
  function ceilToMultiple(n,m){ return Math.ceil(n/m)*m; }
  function floorToMultiple(n,m){ return Math.floor(n/m)*m; }

var Q_SELECTORS = [
  'form[action*="/cart"] input[name="updates[]"]',
  'form[action*="/cart"] input[data-quantity-input]',
  'form[action*="/cart"] quantity-input input[type="number"]',
  'form[action*="/cart"] input[name*="updates"]',

  // ✅ /cart page Varianten: updates[...]
  'form[action*="/cart"] input[name^="updates["]'
];
  function findAllQtyInputs(root){
    root = root || document;
    var out = [];
    Q_SELECTORS.forEach(function(sel){
      root.querySelectorAll(sel).forEach(function(el){ if(out.indexOf(el)===-1) out.push(el); });
    });
    return out;
  }

  var cartCache=null;
  function fetchCart(){
    return fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(json){ cartCache=json; return json; })
      .catch(function(){ cartCache=null; return null; });
  }

function rowInfoFromInput(input){
  var row = input.closest('[data-cart-item],[data-cart-item-key],[data-variant-id]');
  var info = { key:null, lineIndex:null, item:null };

  // 1) Key (wenn Theme ihn liefert)
  if(row){
    info.key = row.getAttribute('data-cart-item-key')
      || (row.dataset && row.dataset.cartItemKey)
      || null;
  }

  // 2) ✅ Dawn /cart liefert sehr oft data-index am input oder parent
  //    Das ist die zuverlässigste Zuordnung zu cart.items[]
  var di = null;
  if(input && input.dataset && input.dataset.index) di = input.dataset.index;

  // manchmal sitzt data-index am Wrapper
  if(!di){
    var wrap = input.closest('[data-index]');
    if(wrap && wrap.dataset && wrap.dataset.index) di = wrap.dataset.index;
  }

  // manchmal: name="updates[1]" → daraus Index ziehen
  if(!di){
    var nm = String(input.getAttribute('name') || '');
    var m = nm.match(/^updates\[(\d+)\]$/);
    if(m) di = m[1];
  }

  info.lineIndex = di ? parseInt(di, 10) : null;
  if(isNaN(info.lineIndex)) info.lineIndex = null;

  // 3) cart item zuordnen (erst key, dann lineIndex)
  if(cartCache && Array.isArray(cartCache.items)){
    var item = null;

    if(info.key){
      item = cartCache.items.find(function(it){ return it.key === info.key; }) || null;
    }

    if(!item && info.lineIndex){
      item = cartCache.items[info.lineIndex - 1] || null;
    }

    info.item = item;
    if(item && !info.key) info.key = item.key;
  }

  return info;
}

  function getProp(item, key){
    if(!item || !item.properties) return null;
    var v = item.properties[key];
    return (v == null) ? null : String(v);
  }

  function getSnapConfig(item){
    var enabled = getProp(item, '_inbus_snap_enabled');
    var on = (enabled === '1' || enabled === 'true');

    if(!on) return { active:false, threshold:0, step:0 };

    var threshold = toInt(getProp(item, '_inbus_snap_threshold'));
    var step      = toInt(getProp(item, '_inbus_snap_step'));

    // RULE: missing/invalid -> snap OFF silently
    if(threshold <= 0 || step <= 0) return { active:false, threshold:0, step:0 };

    return { active:true, threshold:threshold, step:step };
  }

  function getLast(el){ return el && el._inbus_lastVal!=null ? el._inbus_lastVal : null; }
  function setLast(el, v){ if(el) el._inbus_lastVal = v; }

  function adjustValueDirectional(el, raw, threshold, step){
    var prev = getLast(el);
    var s = clampMin1(toInt(raw));

    if (s < threshold) return s;

    var dir = null;

    if (prev != null){
      if (s > prev) dir = 'up';
      else if (s < prev) dir = 'down';
    }

    if (dir === 'down'){
      var down = floorToMultiple(s, step);
      if (down < threshold) return threshold - 1;
      return down;
    }

    return ceilToMultiple(s, step);
  }

    function adjustValueCommitted(raw, threshold, step){
      var s = clampMin1(toInt(raw));

      if (s < threshold) return s;

      return ceilToMultiple(s, step);
    }

  function changeLineQuantity(lineKeyOrIndex, qty, onDone){
    var body;
    if (typeof lineKeyOrIndex === 'string'){
      body = new URLSearchParams({ id: lineKeyOrIndex, quantity: String(qty) });
    } else {
      body = new URLSearchParams({ line: String(lineKeyOrIndex||1), quantity: String(qty) });
    }
    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/x-www-form-urlencoded' },
      body: body.toString(),
      credentials:'same-origin'
    }).then(function(){ onDone && onDone(); })
      .catch(function(){ onDone && onDone(); });
  }

    function handleQtyChange(e){
      var el = e.target;
      if (!(el && el.tagName === 'INPUT')) return;

      var info = rowInfoFromInput(el);
      if(!info.item){
        setLast(el, toInt(el.value));
        return;
      }

      var cfg = getSnapConfig(info.item);
      if(!cfg.active){
        setLast(el, toInt(el.value));
        return;
      }

      var desired = adjustValueDirectional(el, el.value, cfg.threshold, cfg.step);
      if (String(desired) !== String(el.value)){
        el.value = String(desired);
      }
      setLast(el, toInt(el.value));

      changeLineQuantity(info.key || info.lineIndex, desired, function(){});
    }

      function bindAll(scope){
        findAllQtyInputs(scope).forEach(function(el){
          if (el._inbus_bound) return;

          el._inbus_manualEdit = false;

          el.addEventListener('focus', function(){
            el._inbus_manualEdit = false;
          });

          el.addEventListener('input', function(){
            el._inbus_manualEdit = true;
          });

          el.addEventListener('change', function(){
            if(el._inbus_manualEdit){
              return;
            }
            handleQtyChange({ target: el });
          });

          el.addEventListener('blur', function(){
            var info = rowInfoFromInput(el);
            if(!info.item) return;

            var cfg = getSnapConfig(info.item);
            if(!cfg.active) return;

            if(el._inbus_manualEdit){
              var desired = adjustValueCommitted(el.value, cfg.threshold, cfg.step);
              el.value = String(desired);
              setLast(el, desired);
              changeLineQuantity(info.key || info.lineIndex, desired, function(){});
              el._inbus_manualEdit = false;
            }
          });

          el.addEventListener('keydown', function(e){
            if(e.key === 'Enter'){
              e.preventDefault();

              var info = rowInfoFromInput(el);
              if(!info.item) return;

              var cfg = getSnapConfig(info.item);
              if(!cfg.active) return;

              var desired;

              if(el._inbus_manualEdit){
                desired = adjustValueCommitted(el.value, cfg.threshold, cfg.step);
              } else {
                desired = adjustValueDirectional(el, el.value, cfg.threshold, cfg.step);
              }

              el.value = String(desired);
              setLast(el, desired);
              changeLineQuantity(info.key || info.lineIndex, desired, function(){});

              el._inbus_manualEdit = false;
              el.blur();
            }
          });

          setLast(el, toInt(el.value));
          el._inbus_bound = true;
        });
      }

  onReady(function(){
    fetchCart().then(function(){
      bindAll(document);
    });

    var mo = new MutationObserver(function(muts){
      var needsFetch = false;
      for (var i=0;i<muts.length;i++){
        if (muts[i].addedNodes && muts[i].addedNodes.length){
          needsFetch = true; break;
        }
      }
      if (needsFetch){
        fetchCart().then(function(){
          bindAll(document);
        });
      }
    });
    mo.observe(document.body, { childList:true, subtree:true });
  });
})();

/* === INBUS — Auto-Select fix for Drawer (unchanged) === */
(function(){
  document.addEventListener('focusin', function(e){
    var el = e.target;
    if(!el || !el.matches('input[type="number"][name*="quantity"], .cart__qty-input, .quantity__input')) return;

    setTimeout(function(){
      try { el.select(); } catch(_) {}
      el._inbusSelectGuard = true;
    }, 0);
  });

  function guardSelection(e){
    var el = e.target;
    if(!el || !el.matches('input[type="number"][name*="quantity"], .cart__qty-input, .quantity__input')) return;
    if(el._inbusSelectGuard){
      e.preventDefault();
      el._inbusSelectGuard = false;
    }
  }

  document.addEventListener('mouseup', guardSelection, {capture:true, passive:false});
  document.addEventListener('pointerup', guardSelection, {capture:true, passive:false});
})();